import Mock from 'mockjs'
import { builder } from '../builder'

const getHomeSwiper = () => {
  return builder(
    [
      { img: require('../../assets/server/banner.png'), url: 'home' },
      { img: require('../../assets/server/banner.png'), url: 'about' }
    ]
  )
}

const getHomeAbout = () => {
  return builder(
    [
      { img: require('../../assets/server/about/1.png'), name: '公司简介', url: 'about' },
      { img: require('../../assets/server/about/2.png'), name: '公司资质', url: 'about/qualifications' },
      { img: require('../../assets/server/about/2.png'), name: '公司荣誉', url: 'about/honor' },

    ]
  )
}

const getHomeBusiness = () => {
  return builder(
    [

      { name: '积分营销', img: require('../../assets/server/business/1.png'), content: '客维致力打造行业积分营销体系，以数字营销为导向，向客户提供营销和忠诚度整体解决方案。如金融行业：如银行、保险、证券、运营商、互联网、能源运输业、酒店、航空、零售、制造等各行业提供忠诚度计划咨询、积分数据挖掘及跨界营销实施、技术开发移动端及PC端、积分营销方案策划、品牌供应链一系列综合解决方案，有效提高用户忠诚度和粘着度。' },

      { name: '企业采集', img: require('../../assets/server/business/2.png'), content: '客维致力打造行业积分营销体系，以数字营销为导向，向客户提供营销和忠诚度整体解决方案。如金融行业：如银行、保险、证券、运营商、互联网、能源运输业、酒店、航空、零售、制造等各行业提供忠诚度计划咨询、积分数据挖掘及跨界营销实施、技术开发移动端及PC端、积分营销方案策划、品牌供应链一系列综合解决方案，有效提高用户忠诚度和粘着度。' },

      { name: '新媒体电商', img: require('../../assets/server/business/3.png'), content: '客维致力打造行业积分营销体系，以数字营销为导向，向客户提供营销和忠诚度整体解决方案。如金融行业：如银行、保险、证券、运营商、互联网、能源运输业、酒店、航空、零售、制造等各行业提供忠诚度计划咨询、积分数据挖掘及跨界营销实施、技术开发移动端及PC端、积分营销方案策划、品牌供应链一系列综合解决方案，有效提高用户忠诚度和粘着度。' },

      { name: '传统电商', img: require('../../assets/server/business/4.png'), content: '客维致力打造行业积分营销体系，以数字营销为导向，向客户提供营销和忠诚度整体解决方案。如金融行业：如银行、保险、证券、运营商、互联网、能源运输业、酒店、航空、零售、制造等各行业提供忠诚度计划咨询、积分数据挖掘及跨界营销实施、技术开发移动端及PC端、积分营销方案策划、品牌供应链一系列综合解决方案，有效提高用户忠诚度和粘着度。' },

      { name: '员工福利', img: require('../../assets/server/business/5.png'), content: '客维致力打造行业积分营销体系，以数字营销为导向，向客户提供营销和忠诚度整体解决方案。如金融行业：如银行、保险、证券、运营商、互联网、能源运输业、酒店、航空、零售、制造等各行业提供忠诚度计划咨询、积分数据挖掘及跨界营销实施、技术开发移动端及PC端、积分营销方案策划、品牌供应链一系列综合解决方案，有效提高用户忠诚度和粘着度。' }

    ]
  )
}

const getHomeTochnology = () => {
  return builder(
    [
      {
        name: '制定电商',
        img: require('../../assets/server/technology/1.png'),
        content: '各金融行业、航空公司、能源企业等500强企业为了获客、稳定私域流量客群，对定制电商的需求越来越大，纷纷推出电商平台，客维具备丰富的软件开发和运营经验，带您玩转私域流量，为企业提供附加值。'
      },
      {
        name: '客维甄选',
        img: require('../../assets/server/technology/2.png'),
        content: '各金融行业、航空公司、能源企业等500强企业为了获客、稳定私域流量客群，对定制电商的需求越来越大，纷纷推出电商平台，客维具备丰富的软件开发和运营经验，带您玩转私域流量，为企业提供附加值。'
      },
      {
        name: '乐送商城',
        img: require('../../assets/server/technology/3.png'),
        content: '各金融行业、航空公司、能源企业等500强企业为了获客、稳定私域流量客群，对定制电商的需求越来越大，纷纷推出电商平台，客维具备丰富的软件开发和运营经验，带您玩转私域流量，为企业提供附加值。'
      },
      {
        name: '福利平台',
        img: require('../../assets/server/technology/4.png'),
        content: '各金融行业、航空公司、能源企业等500强企业为了获客、稳定私域流量客群，对定制电商的需求越来越大，纷纷推出电商平台，客维具备丰富的软件开发和运营经验，带您玩转私域流量，为企业提供附加值。'
      },
      {
        name: '分销系统',
        img: require('../../assets/server/technology/5.png'),
        content: '各金融行业、航空公司、能源企业等500强企业为了获客、稳定私域流量客群，对定制电商的需求越来越大，纷纷推出电商平台，客维具备丰富的软件开发和运营经验，带您玩转私域流量，为企业提供附加值。'
      },
      {
        name: '企业高定',
        img: require('../../assets/server/technology/6.png'),
        content: '各金融行业、航空公司、能源企业等500强企业为了获客、稳定私域流量客群，对定制电商的需求越来越大，纷纷推出电商平台，客维具备丰富的软件开发和运营经验，带您玩转私域流量，为企业提供附加值。'
      },
    ]
  )
}

const getHomeNews = () => {
  return builder(
    {
      video: [
        // require('../../assets/server/news/news.mp4'),
        require('../../assets/server/news/news2.mp4'),
        // require('../../assets/server/news/news.mp4'),
        require('../../assets/server/news/news2.mp4'),
      ],
      news: [
        {
          title: '这里是关于公司动态的相关文案这里是关于公司动态的相关文案',
          date: '2020-12-14',
          img: require('../../assets/server/about/2.png'),
          content: '这里是关于公司动态的相关文案信息详情这里是关于公司动态的相关文案信息详情这里是关于公司动态的相关文案信息详情这里是关于公司动态的相关文案信息详情这里是关于公司动态的相关文案信息详情这里是关于公司动态的相关文案信息详情这里是关于公司动态的相关文案信息...'
        },
        {
          title: '这里是关于公司动态的相关文案这里是关于公司动态的相关文案',
          date: '2020-12-14',
          img: require('../../assets/server/about/2.png'),
          content: '这里是关于公司动态的相关文案信息详情这里是关于公司动态的相关文案信息详情这里是关于公司动态的相关文案信息详情这里是关于公司动态的相关文案信息详情这里是关于公司动态的相关文案信息详情这里是关于公司动态的相关文案信息详情这里是关于公司动态的相关文案信息...'
        },
        {
          title: '这里是关于公司动态的相关文案这里是关于公司动态的相关文案',
          date: '2020-12-14',
          img: require('../../assets/server/about/2.png'),
          content: '这里是关于公司动态的相关文案信息详情这里是关于公司动态的相关文案信息详情这里是关于公司动态的相关文案信息详情这里是关于公司动态的相关文案信息详情这里是关于公司动态的相关文案信息详情这里是关于公司动态的相关文案信息详情这里是关于公司动态的相关文案信息...'
        },
        {
          title: '这里是关于公司动态的相关文案这里是关于公司动态的相关文案',
          date: '2020-12-14',
          img: require('../../assets/server/about/2.png'),
          content: '这里是关于公司动态的相关文案信息详情这里是关于公司动态的相关文案信息详情这里是关于公司动态的相关文案信息详情这里是关于公司动态的相关文案信息详情这里是关于公司动态的相关文案信息详情这里是关于公司动态的相关文案信息详情这里是关于公司动态的相关文案信息...'
        },
        {
          title: '这里是关于公司动态的相关文案这里是关于公司动态的相关文案',
          date: '2020-12-14',
          img: require('../../assets/server/about/2.png'),
          content: '这里是关于公司动态的相关文案信息详情这里是关于公司动态的相关文案信息详情这里是关于公司动态的相关文案信息详情这里是关于公司动态的相关文案信息详情这里是关于公司动态的相关文案信息详情这里是关于公司动态的相关文案信息详情这里是关于公司动态的相关文案信息...'
        },
        {
          title: '这里是关于公司动态的相关文案这里是关于公司动态的相关文案',
          date: '2020-12-14',
          img: require('../../assets/server/about/2.png'),
          content: '这里是关于公司动态的相关文案信息详情这里是关于公司动态的相关文案信息详情这里是关于公司动态的相关文案信息详情这里是关于公司动态的相关文案信息详情这里是关于公司动态的相关文案信息详情这里是关于公司动态的相关文案信息详情这里是关于公司动态的相关文案信息...'
        }, {
          title: '这里是关于公司动态的相关文案这里是关于公司动态的相关文案',
          date: '2020-12-14',
          img: require('../../assets/server/about/2.png'),
          content: '这里是关于公司动态的相关文案信息详情这里是关于公司动态的相关文案信息详情这里是关于公司动态的相关文案信息详情这里是关于公司动态的相关文案信息详情这里是关于公司动态的相关文案信息详情这里是关于公司动态的相关文案信息详情这里是关于公司动态的相关文案信息...'
        }, {
          title: '这里是关于公司动态的相关文案这里是关于公司动态的相关文案',
          date: '2020-12-14',
          img: require('../../assets/server/about/2.png'),
          content: '这里是关于公司动态的相关文案信息详情这里是关于公司动态的相关文案信息详情这里是关于公司动态的相关文案信息详情这里是关于公司动态的相关文案信息详情这里是关于公司动态的相关文案信息详情这里是关于公司动态的相关文案信息详情这里是关于公司动态的相关文案信息...'
        }, {
          title: '这里是关于公司动态的相关文案这里是关于公司动态的相关文案',
          date: '2020-12-14',
          img: require('../../assets/server/about/2.png'),
          content: '这里是关于公司动态的相关文案信息详情这里是关于公司动态的相关文案信息详情这里是关于公司动态的相关文案信息详情这里是关于公司动态的相关文案信息详情这里是关于公司动态的相关文案信息详情这里是关于公司动态的相关文案信息详情这里是关于公司动态的相关文案信息...'
        }, {
          title: '这里是关于公司动态的相关文案这里是关于公司动态的相关文案',
          date: '2020-12-14',
          img: require('../../assets/server/about/2.png'),
          content: '这里是关于公司动态的相关文案信息详情这里是关于公司动态的相关文案信息详情这里是关于公司动态的相关文案信息详情这里是关于公司动态的相关文案信息详情这里是关于公司动态的相关文案信息详情这里是关于公司动态的相关文案信息详情这里是关于公司动态的相关文案信息...'
        }, {
          title: '这里是关于公司动态的相关文案这里是关于公司动态的相关文案',
          date: '2020-12-14',
          img: require('../../assets/server/about/2.png'),
          content: '这里是关于公司动态的相关文案信息详情这里是关于公司动态的相关文案信息详情这里是关于公司动态的相关文案信息详情这里是关于公司动态的相关文案信息详情这里是关于公司动态的相关文案信息详情这里是关于公司动态的相关文案信息详情这里是关于公司动态的相关文案信息...'
        }, {
          title: '这里是关于公司动态的相关文案这里是关于公司动态的相关文案',
          date: '2020-12-14',
          img: require('../../assets/server/about/2.png'),
          content: '这里是关于公司动态的相关文案信息详情这里是关于公司动态的相关文案信息详情这里是关于公司动态的相关文案信息详情这里是关于公司动态的相关文案信息详情这里是关于公司动态的相关文案信息详情这里是关于公司动态的相关文案信息详情这里是关于公司动态的相关文案信息...'
        }
      ]
    }
  )
}

const getNewsList = () => {
  return builder(
    [
      { title: '这里是关于人才战略的相关文案这里是关于人才战略的相关文案这里是关案这里是', publisher: '李一一', date: new Date('2021-02-05 12:12:12'), id: 1 },
      { title: '这里是关于人才战略的相关文案这里是关于人才战略的相关文案这里是关案这里是', publisher: '李一一', date: new Date('2021-02-05 12:12:12'), id: 2 },
      { title: '这里是关于人才战略的相关文案这里是关于人才战略的相关文案这里是关案这里是', publisher: '李一一', date: new Date('2021-02-05 12:12:12'), id: 3 },
      { title: '这里是关于人才战略的相关文案这里是关于人才战略的相关文案这里是关案这里是', publisher: '李一一', date: new Date('2021-02-05 12:12:12'), id: 4 },
      { title: '这里是关于人才战略的相关文案这里是关于人才战略的相关文案这里是关案这里是', publisher: '李一一', date: new Date('2021-02-05 12:12:12'), id: 5 },
      { title: '这里是关于人才战略的相关文案这里是关于人才战略的相关文案这里是关案这里是', publisher: '李一一', date: new Date('2021-02-05 12:12:12'), id: 1 },
      { title: '这里是关于人才战略的相关文案这里是关于人才战略的相关文案这里是关案这里是', publisher: '李一一', date: new Date('2021-02-05 12:12:12'), id: 1 },
      { title: '这里是关于人才战略的相关文案这里是关于人才战略的相关文案这里是关案这里是', publisher: '李一一', date: new Date('2021-02-05 12:12:12'), id: 1 },
      { title: '这里是关于人才战略的相关文案这里是关于人才战略的相关文案这里是关案这里是', publisher: '李一一', date: new Date('2021-02-05 12:12:12'), id: 1 },
      { title: '这里是关于人才战略的相关文案这里是关于人才战略的相关文案这里是关案这里是', publisher: '李一一', date: new Date('2021-02-05 12:12:12'), id: 1 },
      { title: '这里是关于人才战略的相关文案这里是关于人才战略的相关文案这里是关案这里是', publisher: '李一一', date: new Date('2021-02-05 12:12:12'), id: 1 },
      { title: '这里是关于人才战略的相关文案这里是关于人才战略的相关文案这里是关案这里是', publisher: '李一一', date: new Date('2021-02-05 12:12:12'), id: 1 },
      { title: '这里是关于人才战略的相关文案这里是关于人才战略的相关文案这里是关案这里是', publisher: '李一一', date: new Date('2021-02-05 12:12:12'), id: 1 },
      { title: '这里是关于人才战略的相关文案这里是关于人才战略的相关文案这里是关案这里是', publisher: '李一一', date: new Date('2021-02-05 12:12:12'), id: 1 },
      { title: '这里是关于人才战略的相关文案这里是关于人才战略的相关文案这里是关案这里是', publisher: '李一一', date: new Date('2021-02-05 12:12:12'), id: 1 },
      { title: '这里是关于人才战略的相关文案这里是关于人才战略的相关文案这里是关案这里是', publisher: '李一一', date: new Date('2021-02-05 12:12:12'), id: 1 },
    ]
  )
}

const getPosition = () => {
  return builder(
    [
      {
        title: '大客户代表（六险一金+高底薪+高提成',
        demand: ['商务谈判', '销售管理', '客户资源',],
        location: '广州天河区',
        experience: '1-3',
        education: '大专',
        salary: '6k-10k',
        id: 123

      },
      {
        title: '电商助理（六险一金+高底薪+高提成）',
        demand: ['Office'],
        location: '广州天河区',
        experience: '1-3',
        education: '大专',
        salary: '6k-10k',
        id: 321

      },
      {
        title: '电商助理（六险一金+高底薪+高提成）',
        demand: ['Office'],
        location: '广州天河区',
        experience: '1-3',
        education: '大专',
        salary: '6k-10k',
        id: 123

      }, {
        title: '电商助理（六险一金+高底薪+高提成）',
        demand: ['Office'],
        location: '广州天河区',
        experience: '1-3',
        education: '大专',
        salary: '6k-10k',
        id: 123

      }, {
        title: '电商助理（六险一金+高底薪+高提成）',
        demand: ['Office'],
        location: '广州天河区',
        experience: '1-3',
        education: '大专',
        salary: '6k-10k',
        id: 123

      }, {
        title: '电商助理（六险一金+高底薪+高提成）',
        demand: ['Office'],
        location: '广州天河区',
        experience: '1-3',
        education: '大专',
        salary: '6k-10k',
        id: 123

      }, {
        title: '电商助理（六险一金+高底薪+高提成）',
        demand: ['Office'],
        location: '广州天河区',
        experience: '1-3',
        education: '大专',
        salary: '6k-10k',
        id: 123

      }, {
        title: '电商助理（六险一金+高底薪+高提成）',
        demand: ['Office'],
        location: '广州天河区',
        experience: '1-3',
        education: '大专',
        salary: '6k-10k',
        id: 321

      }, {
        title: '电商助理（六险一金+高底薪+高提成）',
        demand: ['Office'],
        location: '广州天河区',
        experience: '1-3',
        education: '大专',
        salary: '6k-10k',
        id: 123

      },

    ]
  )
}

const getBrandList = () => {
  return builder([
    {
      title: 'PRADA',
      img: require('../../assets/test/brand/prada.jpg'),
      content: '普拉达（PRADA）是意大利奢侈品牌，由玛丽奥·普拉达于1913年在意大利米兰创建。MiucciaPrada的独特天赋在于对新创意的不懈追求，融合了对知识的好奇心和文化兴趣，从而开辟了先驱之路。她不仅能够预测时尚趋势，更能够引领时尚潮流。'
    },
    {
      title: 'PRADA',
      img: require('../../assets/test/brand/prada.jpg'),
      content: '普拉达（PRADA）是意大利奢侈品牌，由玛丽奥·普拉达于1913年在意大利米兰创建。MiucciaPrada的独特天赋在于对新创意的不懈追求，融合了对知识的好奇心和文化兴趣，从而开辟了先驱之路。她不仅能够预测时尚趋势，更能够引领时尚潮流。'
    },
    {
      title: 'PRADA',
      img: require('../../assets/test/brand/prada.jpg'),
      content: '普拉达（PRADA）是意大利奢侈品牌，由玛丽奥·普拉达于1913年在意大利米兰创建。MiucciaPrada的独特天赋在于对新创意的不懈追求，融合了对知识的好奇心和文化兴趣，从而开辟了先驱之路。她不仅能够预测时尚趋势，更能够引领时尚潮流。'
    }
  ])
}

Mock.mock('/api/get-brand-list', 'get', getBrandList)
Mock.mock('/api/homeSwiper', 'get', getHomeSwiper)
Mock.mock('/api/home-about', 'get', getHomeAbout)
Mock.mock('/api/home-business', 'get', getHomeBusiness)
Mock.mock('/api/home-technology', 'get', getHomeTochnology)
Mock.mock('/api/home-news', 'get', getHomeNews)
Mock.mock('/api/get-news-list', 'get', getNewsList)
Mock.mock('/api/get-joinKewei-position', 'get', getPosition)

